<div class="countdown">
    <i class="las la-stopwatch"></i>
    {{ countDown.minutes < 10 ? '0' + countDown.minutes : countDown.minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }} seg
</div>